#import "../fragments/sales-document-template-fragment.graphql"

mutation UpdateQuoteTemplateProduct($input: QuoteProductsUpdateInput!) {
    quoteProductsUpdate(input: $input) {
        salesDocument {
            ...SalesDocumentTemplateFragment
        }
    }
}
